import posthog from "./analytics";
import { storedAttribution } from "./attribution";

// Content-program events. Analytics must never break a page or a tool, so
// every call is guarded; before init (or with no key) posthog.__loaded is
// falsy and we do nothing rather than queue.
const capture = (event, props) => {
  try {
    if (!posthog || !posthog.__loaded) return;
    posthog.capture(event, props);
  } catch {
    /* swallow: tracking is best effort */
  }
};

export const trackToolUsed = (tool, action) => capture("tool_used", { tool, action });
export const trackCta = (page, position) => capture("cta_clicked", { page, position });
export const trackDownload = (file) => capture("download", { file });
export const trackGetApp = (target) =>
  capture("get_app_clicked", {
    target,
    path: window.location.pathname,
    ...storedAttribution(),
  });
export const trackContentView = (type, slug, lang) =>
  capture("content_view", { type, slug, lang });
